import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/utils/api';
import { CompanySettings, CompanySettingsUpdate } from '@/types/companySettings';

export const useCompanySettings = () => {
  return useQuery<CompanySettings>({
    queryKey: ['companySettings'],
    queryFn: async () => {
      const response = await api.get('/company-settings');
      return response.data;
    },
  });
};

export const useUpdateCompanySettings = () => {
  const queryClient = useQueryClient();
  
  return useMutation<CompanySettings, Error, CompanySettingsUpdate>({
    mutationFn: async (data) => {
      const response = await api.put('/company-settings', data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companySettings'] });
    },
  });
};